var triads = require('./lib/triads');

var infer = require('./lib/infer');

var name = require('./lib/name');

module.exports = exports = {
  infer: infer,
  triads: triads,
  name: name
};